<template>
  <ContentWrapper>
    <div class="file-search" v-show="data.params.mode=='list'">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" @reset="reset"/>
        </div>
      </div>
    </div>
    <div div class="content-heading mt-1">
        <div>검색목록</div>
    </div>
    <div class="card card-default">
      <div class="card-body">
        <form data-vv-scope="edit">
          <table class="table table-bordered">
            <colgroup>
              <col width="3%"/>
              <col width="17%"/>
              <col width="15%"/>
              <col width="25%"/>
              <col width="20%"/>
              <col width="20%"/>
            </colgroup>
            <tr>
              <td><input type="checkbox" @click="SelectItemAllChecked(data.list, checkedAll, checked)" v-model='checkedAll' @change="SelectItemAll(data.list , 'top')"></td>
              <td @click="dataAction.sort(search,'cont_seq')">ID<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td @click="dataAction.sort(search,'purpose_cd')">목적<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td @click="dataAction.sort(search,'cont_type_cd')">유형<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td @click="dataAction.sort(search,'cont_title')">제목<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td @click="dataAction.sort(search,'reg_dt')">수정일<em class="fa-2s mr-2 fas fa-sort"></em></td>
            </tr>

          <tr v-for="(item, index) in data.list" :key="`search_${index}`">
            <td input-type><input type="checkbox" v-model='checked[index]' @change="SelectItem(index,checked[index],'top')" :checked="checked[index] == 'true' ? 'true' : 'false'"></td>
            <td>{{ item.contSeq }}</td>
            <td>{{ onlinePurposeCd.get(item.purposeCd) }}</td>
            <td>{{ onlineContTypeCd.get(item.contTypeCd) }}</td>
            <td>{{ item.contTitle}}</td>
            <td>{{ item.regDt }}</td>
          </tr>
          </table>
        </form>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" 
            @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
      <div class="card-footer">
        <div class="card-tool float-right">
          <b-button @click="popupClose()" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">취소</b-button>
          <b-button @click="SelectItemShow(); " class="btn btn-xs btn-outline-danger mr-2" variant="outline-info mr-2">선택목록 이동</b-button>
          <b-button @click="save('list')" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">바로저장</b-button>
        </div>
      </div>
    </div>
    <div div class="content-heading mt-1">
        <div>선택목록</div>
    </div>
    <div class="card card-default">
      <div class="card-body">
        <form data-vv-scope="edit">
          <table class="table table-bordered">
            <colgroup>
              <col width="3%"/>
              <col width="17%"/>
              <col width="15%"/>
              <col width="25%"/>
              <col width="20%"/>
              <col width="20%"/>
            </colgroup>
           <tr>
              <td><input type="checkbox" @click="SelectItemAllChecked(selectShowData, selectCheckedAll, selectChecked)" v-model='selectCheckedAll' @change="SelectItemAll(selectShowData , 'bottom')"></td>
              <td @click="dataAction.sort(search,'cont_seq')">ID<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td @click="dataAction.sort(search,'purpose_cd')">목적<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td @click="dataAction.sort(search,'cont_type_cd')">유형<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td @click="dataAction.sort(search,'cont_title')">제목<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td @click="dataAction.sort(search,'reg_dt')">수정일<em class="fa-2s mr-2 fas fa-sort"></em></td>
            </tr>

          <tr v-for="(item, index) in selectShowData" :key="`select_${index}`">
            <td input-type><input type="checkbox" v-model='selectChecked[index]' @change="SelectItem(index,selectChecked[index],'bottom')" :checked="selectChecked[index] == 'true' ? 'true' : 'false'"></td>
            <td>{{ item.contSeq }}</td>
            <td>{{ onlinePurposeCd.get(item.purposeCd) }}</td>
            <td>{{ onlineContTypeCd.get(item.contTypeCd) }}</td>
            <td>{{ item.contTitle }}</td>
            <td>{{ item.regDt }}</td>
          </tr>
          </table>
        </form>
      </div>
      <div class="card-footer">
        <div class="card-tool float-right">
          <b-button @click="popupClose()" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">취소</b-button>
          <b-button @click="SelectItemHide();" class="btn btn-xs btn-outline-danger mr-2" variant="outline-info mr-2">선택취소</b-button>
          <b-button @click="save('checklist')" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">저장</b-button>
        </div>
      </div>
    </div>
    <!-- // 상세 -->
  </ContentWrapper>
</template>
<script>
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import {getOnlineContentsList, getOnlineContentsItem, saveOnlineContentsList} from "@/api/online/OnlineContentsApi"
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject, fileDivCd, fileDivCdMap, onlinePurposeCd, onlineContTypeCd} from "@/utils/Constants";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import Datepicker from 'vuejs-datepicker'

export default {
  components: {SchDateRange, SchText, Pagenation, Datepicker},
  props: {
    extFileId: '',
    atrbInfo : '',
    pContSeq1 : '',
    pContSeq2 : '',
    orgContSeq : '',
  },
  setup(props, context) {
    const schOptions = [{value: 'cont_seq', text: '콘텐츠 아이디'},{value: 'cont_title', text: '콘텐츠명'}]
    const _dataObject = _.cloneDeep(dataObject);
    const data = reactive(_dataObject)
    const selectDataT = reactive([]);
    const selectDataB = reactive([]);
    const selectShowData = reactive([]);
    const checked = reactive([]);
    const checkedAll = ref(false);
    const selectChecked = reactive([]);
    const selectCheckedAll = ref(false);

    const modal_state = ref(true);

    data.schOptions = schOptions // 검색 type 선택

    const loadData = async () => {
      // modal open
      if(props.extFileId){
        data.params.extFileId = props.extFileId
        data.params.mode = 'detail';
        let result = await getOnlineContentsItem(data.params);
        data.row = result.data;
      }else{
        let result = await getOnlineContentsList(data.params);
        data.list = result.data;
        data.count = result.count;
      }

    }
    onMounted(loadData)

    const SelectItem = (i,checked, location) => {
      if(checked){
        if(location =='top'){
          selectDataT.push(data.list[i]);
        }
        else{
           selectDataB.push(selectShowData[i]);
        }
        checked = false;
      }
      else{
        if(location =='top'){
          selectDataT.map((row, j ) => {
            if(row.contSeq === data.list[i].contSeq){
                selectDataT.splice(j,1);
            }
          });
          checkedAll.value = false;
        }
        else{
           selectDataB.map((row, j ) => {
            if(row.contSeq === selectShowData[i].contSeq){
                selectDataB.splice(j,1);
            }
          });
          selectCheckedAll.value = false;
        }
      }
    }

    const DeleteItem = (i,checked) => {
      if(checked){
        selectDataT.push(data.list[i]);
      }
      else{
          selectDataT.map((row, j ) => {
            if(row.contSeq === data.list[i].contSeq){
              selectDataT.splice(j,1);
            }
          }
      )}
    }


    const SelectItemAll = (item, location) => {
     item.map((row, j ) => {
       if(location == 'top')
        selectDataT.push(row);
        else
        selectDataB.push(row);
      });
    }
    
    const SelectItemAllChecked = (item, checkedAll, checked) => {
      item.map((row, j ) => {
        if(!checkedAll){
         checked[j] = true;
        }
        else{
          checked[j] = false;
        }
      });
    }

     const SelectItemHide = () => {
      let _temp;
      _temp = (selectDataB.filter(x=> selectShowData.includes(x))); //겹치는 부분
      
       if(selectCheckedAll.value){
          selectShowData.splice(0,selectShowData.length);  
      }
      else{
        for(var i=0; i<_temp.length ;i++){
          selectShowData.map((row , j) => {
            if(row.contSeq == _temp[i].contSeq){
              selectShowData.splice(j,1);  
            }
          });
        }
      }
      _temp = reactive([]);
      checkRemove();
    }

    const SelectItemShow = () => {
      let _temp;
      _temp = (selectDataT.filter(x=> !selectShowData.includes(x)));
    
      _temp.map((row , i) => {
        if(row.contSeq != null){
          selectShowData.push(row);  
        }
      });

      _temp = reactive([]);
      selectDataT.splice(0, selectDataT.length)
      checkRemove();

    }

   

    const checkRemove = () => { //체크박스 체크 해제 
      for(var i=0; i< checked.length ; i++){
        checked[i] = false;
      } 
      for(var i=0; i< selectChecked.length ; i++){
        selectChecked[i] = false;
      } 
      checkedAll.value = false;
      selectCheckedAll.value = false;
    }

    const popupClose = () => {
      context.emit('modal-state', 'fileOnline');
    }

    const save = (type) => {
      const selectedArray = type == 'list' ? selectDataT : selectDataB;
      if(selectedArray.length == 0 ){
        alert("선택된 온라인 개체가 없습니다.");
        return;
      }
      const paramList = selectedArray.map((row) => {
        return {
          pcontSeq : props.pContSeq2 || props.pContSeq1,
          contSeq : row.contSeq,
          purposeCd : row.purposeCd,
          contTypeCd : row.contTypeCd,
          contTitle : row.contTitle,
          menuType : 'textBook',
        }
      });
      //console.log('paramList:', paramList);
      
      methods().saveOnlineContents(paramList);
      //popupClose();
      context.emit('get-data', {
        contSeq : props.orgContSeq,
        atrbInfo : props.atrbInfo,
      });
    }

    return {
      data,
      selectDataT,
      selectDataB,
      selectShowData,
      SelectItem,
      DeleteItem,
      SelectItemAll,
      SelectItemAllChecked,
      SelectItemShow,
      SelectItemHide,
      checked,
      fileDivCd,
      selectChecked,
      selectCheckedAll,
      checkedAll,
      checkRemove,
      popupClose,
      onlinePurposeCd,
      onlineContTypeCd,
      save,
      ...methods(props, context),
      dataAction: new TableActionClass(data),
    }
  },
}

function methods() {
  var context = {};
  context["getOnlineContentsList"] = getOnlineContentsList;  // get list
  context["getOnlineContentsItem"] = getOnlineContentsItem;  // get item
  context["saveOnlineContentsList"] = saveOnlineContentsList; // save itemList

  // 목록
  async function search() {
    let _params = this.data.params;
    let result = await getOnlineContentsList(_params);
    this.data.list = result.data;
  }

  // 상세
  async function detail(_item){
    this.data.params.mode = 'detail';
    props.extFileId = _item.extFileId;
    let _params = {
      contentsId : _item.extFileId,
      mode : 'detail'
    }
    let result = await getOnlineContentsItem(_params);
    this.data.row = result.data;
  }

  async function saveOnlineContents(params){
    await saveOnlineContentsList(params);
  }

  //  // 저장
  // async function saveMapping(params) {
  //   // const validForm = await this.$validator.validateAll('edit').then((result) => {
  //   //   return result;
  //   // });
  //   // if (validForm) {
  //   //   let _params = this.data.row
  //   //   await this.dataAction.execute("saveCsFile", context, _params);
  //   //   this.search();
  //   // }
  //   return saveCsFileMappingList(params); 
  // }


  // 초기화
  async function reset() {
    //this.dataAction.clear();
  }

  return {reset, search, detail, saveOnlineContents}
}


</script>